import styled from "styled-components";
import { theme } from "../../theme";

const Divider = styled.div<{ color?: string }>`
  width: 100%;
  height: 1px;
  background-color: ${(props) => props.color || theme.colors.grey05};
`;

export default Divider;
